import { APP_BUNDLES, EXAM_TITLES, BUNDLE_APP_NAME, IS_BUNDLE_APP, PAYWALL_COPY } from './_shared/brand-data'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CISSP,
  PRACTICE_TEST as PRACTICE_TEST_CISSP,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CISSP,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CISSP,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CISSP,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CISSP,
} from './cissp'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CCSP,
  PRACTICE_TEST as PRACTICE_TEST_CCSP,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CCSP,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CCSP,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CCSP,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CCSP,
} from './ccsp'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_SSCP,
  PRACTICE_TEST as PRACTICE_TEST_SSCP,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_SSCP,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_SSCP,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_SSCP,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_SSCP,
} from './sscp'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CC,
  PRACTICE_TEST as PRACTICE_TEST_CC,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CC,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CC,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CC,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CC,
} from './cc'

import { IMAGES } from "../lzapp_web_common_code/assets";
import { USER_DEAFULT_KEY } from "../lzapp_web_common_code/constant/event";

export { APP_BUNDLES, BUNDLE_APP_NAME, IS_BUNDLE_APP, PAYWALL_COPY }

export const APP_DATA = {
  DISPLAY_APP_NAME: 'CISSP-CCSP-SSCP-CC ISC2 Official App',
};

export const GET_APP_NAME = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'CISSP';
};

export const GET_EXAM_DISPLAY_TITLE = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'CISSP';
}

const APP_NAME = "ISC2";

export const GET_APP_NAME_FOR_COLLECTION = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  const bundle = APP_BUNDLES.find(b => b.key === result);
  return bundle ? bundle.bundle_firebase_collection_name : 'CISSP';
};

const QUESTION_VERSIONS = {
  'cissp': QUESTION_VERSION_OF_JSON_CISSP,
  'ccsp': QUESTION_VERSION_OF_JSON_CCSP,
  'sscp': QUESTION_VERSION_OF_JSON_SSCP,
  'cc': QUESTION_VERSION_OF_JSON_CC,
};

export const GET_QUESTION_VERSION_OF_JSON = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  return QUESTION_VERSIONS[result] || QUESTION_VERSION_OF_JSON_CISSP;
};

export const app_url = "https://www.learnzapp.com/apps/cissp";

const PRACTICE_TESTS = {
  'cissp': PRACTICE_TEST_CISSP,
  'ccsp': PRACTICE_TEST_CCSP,
  'sscp': PRACTICE_TEST_SSCP,
  'cc': PRACTICE_TEST_CC,
};

export const GET_PRACTICE_TEST = (SELECTED_BUNDLE) => {
  return PRACTICE_TESTS[SELECTED_BUNDLE] || PRACTICE_TEST_CISSP;
};

const DOMAIN_LISTS = {
  'cissp': APP_DOMAIN_LIST_CISSP,
  'ccsp': APP_DOMAIN_LIST_CCSP,
  'sscp': APP_DOMAIN_LIST_SSCP,
  'cc': APP_DOMAIN_LIST_CC,
};

export const GET_APP_DOMAIN_LIST = (SELECTED_BUNDLE) => {
  return DOMAIN_LISTS[SELECTED_BUNDLE] || APP_DOMAIN_LIST_CISSP;
};

const STUDY_QUESTION_MENUS = {
  'cissp': GET_STUDY_QUESTION_MENU_CISSP,
  'ccsp': GET_STUDY_QUESTION_MENU_CCSP,
  'sscp': GET_STUDY_QUESTION_MENU_SSCP,
  'cc': GET_STUDY_QUESTION_MENU_CC,
};

export const GET_STUDY_QUESTION_MENU = (SELECTED_BUNDLE) => {
  const menuFn = STUDY_QUESTION_MENUS[SELECTED_BUNDLE] || GET_STUDY_QUESTION_MENU_CISSP;
  let menu = menuFn();

  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Questions (Testing)',
      key: 'all_questions_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }

  return menu;
};

const FLASH_CARD_MENUS = {
  'cissp': GET_FLASH_CARD_MENU_CISSP,
  'ccsp': GET_FLASH_CARD_MENU_CCSP,
  'sscp': GET_FLASH_CARD_MENU_SSCP,
  'cc': GET_FLASH_CARD_MENU_CC,
};

export const GET_FLASH_CARD_MENU = (SELECTED_BUNDLE) => {
  const menuFn = FLASH_CARD_MENUS[SELECTED_BUNDLE] || GET_FLASH_CARD_MENU_CISSP;
  return menuFn();
};

const ARTICLE_MENUS = {
  'cissp': GET_ARTICLE_MENU_CISSP,
  'ccsp': GET_ARTICLE_MENU_CCSP,
  'sscp': GET_ARTICLE_MENU_SSCP,
  'cc': GET_ARTICLE_MENU_CC,
};

export const GET_ARTICLE_MENU = (SELECTED_BUNDLE) => {
  const menuFn = ARTICLE_MENUS[SELECTED_BUNDLE] || GET_ARTICLE_MENU_CISSP;
  let menu = [...menuFn()];

  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Articles (Testing)',
      key: 'all_articles_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }

  return menu;
};

export const GET_TUTORIALS = () => {
  return [
    {
      title: `Official ISC2 Study App`,
      image: IMAGES.slide_1,
      description:
        'Ace your exam on the first try with this comprehensive study app! \nOver 5000 practice questions and 2000 flashcards to help you succeed in ISC2 exams CISSP, CCSP, SSCP and CC',
    },
    {
      title: "Readiness Score",
      image: IMAGES.slide_2,
      description:
        "The readiness score in the app provides a quick and easy way for you to assess your level of preparedness for the real exam, and to identify areas where you need to focus your study efforts in order to improve their chances of success.",
    },
    {
      title: "Practice makes Perfect!!",
      image: IMAGES.slide_3,
      description:
        "Create your own custom tests by choosing the topics and the number of questions or take pre-built practice tests and mock exams. \nThe custom test engine creates personalized tests with new and your weakest questions.",
    },
    {
      title: "Track your Progress",
      image: IMAGES.slide_4,
      description:
        "Keep track of your progress through the study materials and see how much you have left to complete. \nView the history of your completed tests and re-take any of them as needed.",
    },
    {
      title: "Available on-the-go",
      image: IMAGES.slide_5,
      description:
        "The app is available on both iOS and Android devices, so you study anywhere, anytime. \nYou can seamlessly access and work with your data across multiple devices.",
    },
  ];
};

export const STRING = {
  share_message:
    "Hey there, I am using this app to prepare for (ISC)2 CISSP, CCSP, SSCP and CC certification exams. I think you will find it very useful. Check it out " +
    app_url,
};

export const THIRD_PARTY_CONFIG = {
  STRIPE_PRODUCT_ID: process.env.REACT_APP_STRIPE_PRODUCT_ID,
};

// Display name for the Stripe product on user-facing invoices.
// Each brand build sets its own value (matches the product name in the Stripe dashboard).
// Static, so it also relabels PAST invoices (accepted when CC was added, PR #106).
export const STRIPE_PRODUCT_DISPLAY_NAME = 'ISC2 Official App - CISSP, CCSP, SSCP and CC Prep';

export const ANALYTICS_CONFIG = {
  providers: ['bigquery'],
  bigquery: {
    endpoint: 'https://trackevent-ak4semtiha-uc.a.run.app'
  },
  posthog: {
    apiKey: process.env.REACT_APP_POSTHOG_KEY,
    host: 'https://us.i.posthog.com'
  }
};

export const PAYWALL_COLUMNS = null;

export const IS_TEST_MODE = false;
export const IS_VISIBLE_COMMUNITY = true;

// Home smart-nudge continuation card — enabled for the ISC2 bundle (all exams).
export const NUDGE_CARD_ENABLED = true;

// Metered article unlocks — 5 permanent unlocks per DAY (any domain, UTC
// midnight reset) for free users, replacing the legacy
// first-num_articles-per-domain cap. The meter is per exam (unlocks live under
// each exam's own collection). See docs/ARTICLES_METERING_GUIDE.md.
export const METERED_ARTICLE_UNLOCKS = 5;
export const METERED_ARTICLE_PERIOD = 'day';

// Post-sign-in welcome modal title (web twin of mobile WELCOME_DETAILS.welcomeModalTitle;
// title matches the mobile brand config so the greeting is identical cross-platform).
export const WELCOME_DETAILS = {
    welcomeModalTitle: 'Welcome to ISC2 Prep!',
};
